<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Capture" subtitle="Manage the data capture for new subscriptiions." :readonly="$authorised('mem/subscriptions/access', 'read')">

		<app-content-head-actions-item text="Create" icon="create" v-on:click="onCreateClick" />
		<app-content-head-actions-item text="Delete" icon="delete" :danger="true" :disabled="!selected.length" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no data capture found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Name" />
				<app-table-column text="Type" />
				<app-table-column />

			</app-table-head>

			<app-table-body :sortable="sortedIndex" v-on:sorted="onSorted">

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.name" />
					<app-table-cell-text :text="$constants.membership.capture.typeName[item.type]" />
					<app-table-cell-select v-if="!item.role" :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />
					<app-table-cell-text v-if="item.role" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			layout: 'auto 200px 40px',
			endpoint: 'membership/members/captures',
			live: 'membership/members/captures',
			edit: 'Membership.Members.Captures.Edit'
		}

	}

}

</script>

<style scoped>

</style>